import { CollapseData } from './components/datatable-table/interfaces/collapse-data.interface';
import { DataTable, Sort } from './interfaces/datatable.interface';
import { Component, Input, OnInit } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { isObservable } from 'rxjs';

@Component({
  selector: 'app-datatable',
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.scss']
})
export class DatatableComponent implements OnInit {

  id: string;
  @Input() datatable: DataTable;

  loading = false;
  response;
  data = [];

  filtros = {};
  ultimoFiltro = null;
  rebuildFiltros = false;
  sorts: Sort[] = [];
  size = 20;
  page = 1;
  total = 0;

  calculatingTotal: boolean = false;

  constructor() {
    this.id = uuidv4();
  }

  ngOnInit(): void {
    this.configurarHooks();
    this.configurarPaginacion();
    this.configurarSorts();
    this.setLoading(true);
    if (!this.datatable.filtrosMagicos) {
      this.cargarDatos();
    }
    this.datatable.hooks.onNewDatatableId(this.id);
  }

  configurarHooks() {
    this.datatable.hooks = this.datatable.hooks || {};
    if (!this.datatable.hooks.onNewDatatableId) {
      this.datatable.hooks.onNewDatatableId = (datatableId: string) => {};
    }
    if (!this.datatable.hooks.onLoading) {
      this.datatable.hooks.onLoading = (loading: boolean) => {};
    }
    if (!this.datatable.hooks.onData) {
      this.datatable.hooks.onData = (data: any[]) => {};
    }
    if (!this.datatable.hooks.onService) {
      this.datatable.hooks.onService = (filtros, sorts: Sort[], page: number, limit: number) => {};
    }
    if (!this.datatable.hooks.onResponse) {
      this.datatable.hooks.onResponse = (data: any) => {};
    }
    if (!this.datatable.hooks.onCollapseData) {
      this.datatable.hooks.onCollapseData = (collapseData: CollapseData[]) => {};
    }
  }

  configurarPaginacion() {
    if (this.datatable.paginacion.limites == null) {
      this.datatable.paginacion.limites = [10, 20, 30, 50, 100];
    }
    if (this.datatable.paginacion.limiteIndex == null) {
      this.datatable.paginacion.limiteIndex = 1;
    }
    if (this.datatable.paginacion.mostrarLimites == null) {
      this.datatable.paginacion.mostrarLimites = true;
    }
    if (this.datatable.paginacion.mostrarPaginacion == null) {
      this.datatable.paginacion.mostrarPaginacion = true;
    }
    if (this.datatable.paginacion.usarTotal == null) {
      this.datatable.paginacion.usarTotal = true;
    }
    this.size = this.datatable.paginacion.limites[this.datatable.paginacion.limiteIndex];
  }

  configurarSorts() {
    if (this.datatable.sortDefectos) {
      this.datatable.sortDefectos.forEach(sort => {
        const columnas = this.datatable.columnas.filter(c => c.sortKey === sort.key);
        sort.columna = columnas.length > 0 ? columnas[0] : null;
        this.sorts.push(sort);
      });
    }
  }

  cargarDatos(force: boolean = false) {
    if (!this.datatable.servicio) {
      this.data = this.datatable.data(null);
      this.total = this.data.length;
      this.datatable.hooks.onData(this.data);
      this.setLoading(false);
      return;
    }
    let filtrosJSONStringified = JSON.stringify(this.filtros);
    if (force || this.ultimoFiltro === null || this.ultimoFiltro !== filtrosJSONStringified) {
      this.setLoading(true);
      this.datatable.hooks.onService(this.filtros, this.sorts, this.page, this.size);
      this.datatable.servicio(this.filtros, this.sorts, this.page, this.size)
      .subscribe(response => {
        this.response = response;
        this.data = this.datatable.data(response)
        this.datatable.hooks.onResponse(this.response);
        this.datatable.hooks.onData(this.data);
        this.calculateTotal(response);
      })
      .add(() => this.setLoading(false));
      this.ultimoFiltro = filtrosJSONStringified;
    }
  }

  calculateTotal(response) {
    this.calculatingTotal = true;
    if (!response) {
      this.total = this.data.length;
      this.calculatingTotal = false;
      return;
    }
    const totalResponse = this.datatable.paginacion.total(response);
    if ( isObservable(totalResponse) ) {
      totalResponse.subscribe((total: number) => {
        this.total = total;
        this.calculatingTotal = false;
      })
    } else {
      this.total = totalResponse || 0;
      this.calculatingTotal = false;
    }
  }

  setLoading(loading: boolean) {
    this.loading = loading;
    this.datatable.hooks.onLoading(this.loading);
  }

  existeAlMenosUnaColumnaAMostrar() {
    return this.datatable.columnas.some(x => x.mostrar !== false);
  }

  filtrosCambiados(filtros) {
    this.filtros = filtros;
    this.rebuildFiltros = !this.rebuildFiltros;
    this.page = 1;
    this.cargarDatos();
  } 

  sortCambiados(sorts) {
    this.sorts = sorts;
    this.cargarDatos(true);
  }

  paginaCambiada(page) {
    this.page = page;
    this.cargarDatos(true);
  }

  sizeCambiado(size) {
    this.size = size;
    this.cargarDatos(true);
  }

}
